import React from 'react';
// ModalContainer가 default export인 경우
import ModalContainer from './CustomLargeModalStyle';
// Dim은 named export로 가져와야 합니다
import { Dim } from './Dim';

function CustomLargeModal({ open, title, children, cancel, submit }) {
  if (!open) return null;

  return (
    <Dim open={open} onClick={(e) => e.stopPropagation()}> {/* 클릭이 부모 요소로 전파되지 않도록 설정 */}
      <ModalContainer onClick={(e) => e.stopPropagation()}> {/* Dim 내부 클릭을 막기 위해 stopPropagation 추가 */}
        <div className="title">{title}</div>
        <div className="con">{children}</div>
        <div className="btn">
          <button type="button" className="cancel" onClick={cancel}>취소</button>
          <button type="button" className="confirm" onClick={submit}>확인</button>
        </div>
      </ModalContainer>
    </Dim>
  );
}

export default CustomLargeModal;
